import styled from 'styled-components';
import {palette} from '@/styles/palette';
import {SelectListItem} from '../SelectList';

export const Menu = styled.div`
  background-color: ${palette.white};
  border-radius: 5px;
  border: solid 1px ${palette.gray300};
  overflow: hidden;
`;

export const MenuItem = styled(SelectListItem)`
  min-width: 50px;
  text-align: center;
  font-weight: 700;
  padding: 8px;
`;
